function isWide(p) {
    return p?.isWide === true;
}
/**
 * Decide whether a page should render solo in double-spread mode based on its
 * decoded natural size — used when the manifest carried no dimensions and no
 * explicit `isWide`. Landscape (ratio > 1) ⇒ wide.
 */
export function isNaturallyWide(page, naturalWidth, naturalHeight) {
    if (page.isWide !== undefined)
        return page.isWide;
    if (page.width !== undefined && page.height !== undefined)
        return false; // manifest already knew
    if (naturalHeight <= 0 || naturalWidth <= 0)
        return false;
    return naturalWidth / naturalHeight > 1;
}
/** Build the spread list for a manifest under the given layout options. Pure. */
export function buildSpreads(pages, opts) {
    const n = pages.length;
    if (n === 0)
        return [];
    if (opts.layout !== 'paged-double') {
        return pages.map((p, i) => ({ index: i, pages: [p.index], leading: p.index }));
    }
    const out = [];
    let i = 0;
    const reverse = opts.direction === 'rtl' || opts.direction === 'vertical';
    const push = (ids, leading) => {
        const visual = reverse && ids.length === 2 ? [ids[1], ids[0]] : ids;
        out.push({ index: out.length, pages: visual, leading });
    };
    if (opts.spreadOffset === 1) {
        push([pages[0].index], pages[0].index);
        i = 1;
    }
    while (i < n) {
        const cur = pages[i];
        const next = pages[i + 1];
        if (isWide(cur) || !next || isWide(next)) {
            push([cur.index], cur.index);
            i += 1;
        }
        else {
            push([cur.index, next.index], cur.index);
            i += 2;
        }
    }
    return out;
}
/** Index of the spread that contains `pageIndex` (0 if not found). */
export function spreadIndexForPage(spreads, pageIndex) {
    const found = spreads.findIndex((s) => s.pages.includes(pageIndex));
    return found === -1 ? 0 : found;
}
/** Clamp a spread index into range. */
export function clampSpreadIndex(spreads, index) {
    if (spreads.length === 0)
        return 0;
    return Math.min(spreads.length - 1, Math.max(0, index));
}
//# sourceMappingURL=spreads.js.map